import http from '@/services/http'
import { delayed } from '@/utils'
import { sum } from 'lodash'

export default {
  namespaced: true,
  state: {
    fetchInProgress: false,
    application: getEmptyApplication(),

    saveRatingInProgress: false,
  },
  mutations: {
    START_FETCH(state) {
      state.fetchInProgress = true
    },
    STOP_FETCH(state) {
      state.fetchInProgress = false
    },
    SET_APPLICATION(state, application) {
      state.application = application
    },
    CLEAR(state) {
      state.application = getEmptyApplication()
    },

    START_SAVING_RATING(state) {
      state.saveRatingInProgress = true
    },
    STOP_SAVING_RATING(state) {
      state.saveRatingInProgress = false
    },
    SET_RATING(state, { rating, note }) {
      state.application.ratings.mine.overall = rating
      state.application.ratings.mine.note = note
    },
    SET_NOTE(state, note) {
      state.application.ratings.mine.note = note
    },
    SET_ACCEPTED(state, value) {
      state.application.accepted = value
    },
  },
  getters: {
    averageRating: getAverageRating,
    averageRatingText: (state) => {
      const avg = getAverageRating(state)
      return avg.toFixed(1)
    },
    averageRatingFixed: (state) => {
      const avg = getAverageRating(state)
      return parseFloat(avg.toFixed(1))
    },
  },
  actions: {
    async fetch(
      { commit, state },
      { organizationId, programId, applicationId },
    ) {
      return await fetchApplication(
        { commit, state },
        { organizationId, programId, applicationId },
      )
    },

    async saveRating({ commit, state }, { rating, note = '' }) {
      commit('START_SAVING_RATING')
      const url = `/organizations/${state.application.organization_id}/rate-startup-application`
      const request = http.postAuthed(url, {
        program_id: state.application.program_id,
        organization_id: state.application.organization_id,
        startup_id: state.application.startup_id,
        application_id: state.application.id,
        rating,
        note,
      })
      try {
        commit('SET_RATING', { rating, note })
        await request
      } finally {
        commit('STOP_SAVING_RATING')
      }
    },

    async saveAccepted({ commit, state }, value) {
      const url = `/organizations/${state.application.organization_id}/programs/${state.application.program_id}/applications/${state.application.id}/set-accepted`
      const request = http.postAuthed(url, {
        organization_id: state.application.organization_id,
        application_id: state.application.id,
        accepted: value,
      })
      try {
        await request
        commit('SET_ACCEPTED', value)
      } finally {
      }
    },
  },
}

function getAverageRating(state) {
  const allRatings = state.application.ratings.others
    .concat(state.application.ratings.mine)
    .filter((r) => r.overall)
  if (allRatings.length) {
    return sum(allRatings.map((r) => r.overall)) / allRatings.length
  } else {
    return 0
  }
}

async function fetchApplication(
  { commit, state },
  { organizationId, programId, applicationId, delay = 0 },
) {
  commit('START_FETCH')
  const url = `/organizations/${organizationId}/programs/${programId}/applications/${applicationId}`
  const request = http.getAuthed(url)
  try {
    const response = await delayed(request, delay)
    commit('SET_APPLICATION', response.data)
    return state.application
  } finally {
    commit('STOP_FETCH')
  }
}

function getEmptyApplication() {
  return { ratings: { mine: {}, others: [] } }
}
